import { stripeBgColor } from './StripeStore';

export const updateStripeBgColor = (value) => stripeBgColor.update(oldValue => value);
